export const getOptimusValuesBysensor = (typeDevice, sensorParameters) => {
    return sensorParameters
        .filter(sensor => sensor.sensor.tipoSensor.nombre === typeDevice)
        .map(sensor => ({
            maximo: sensor.maximo,
            tipoSensorId: sensor.sensor.tipoSensor._id
        }))[0];
};
